import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgDatabaseImportFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.946 11.354c.178.008.33-.13.33-.308a548 548 0 0 1-.008-2.702.2.2 0 0 0-.304-.17l-.206.124c-1.29.73-2.69 1.06-4.12 1.28-.66.1-1.33.16-2 .21-1.3.09-2.6.05-3.89-.1-.93-.1-1.86-.27-2.77-.53-.72-.21-1.43-.46-2.09-.84a6 6 0 0 1-.24-.142.201.201 0 0 0-.31.17c.003.73.007 2.36 0 3.242-.01.43.14.78.41 1.08.42.44.93.72 1.47.95.78.34 1.59.55 2.42.71.81.16 1.63.25 2.45.3.67.037 1.333.048 2.003.025a.3.3 0 0 0 .233-.124 7.87 7.87 0 0 1 6.622-3.175M10.673 16.434a17 17 0 0 1-2.215-.176c-.74-.11-1.47-.25-2.2-.42-.85-.2-1.67-.5-2.44-.95l-.17-.104a.202.202 0 0 0-.31.17c.003.723.005 2.33-.01 3.204 0 .52.19.91.54 1.23.4.38.87.63 1.36.84.87.37 1.78.59 2.7.75a20 20 0 0 0 2.7.263c.196.01.34-.18.299-.373a7.8 7.8 0 0 1-.17-1.62c0-.837.13-1.638.375-2.398a.315.315 0 0 0-.292-.414q-.084 0-.167-.002M3.85 6.18c.459.437 1.004.71 1.569.936 1.019.41 2.078.633 3.152.778.906.122 1.817.184 2.552.173 1.714.002 3.234-.142 4.73-.52.746-.188 1.475-.433 2.157-.82.375-.212.725-.46.996-.823.358-.48.364-1.039-.001-1.512a2.7 2.7 0 0 0-.424-.439c-.581-.475-1.25-.75-1.937-.979-1.224-.405-2.482-.605-3.754-.695-1.736-.124-3.465-.06-5.183.26-.933.172-1.848.415-2.72.826-.464.22-.907.48-1.263.882-.296.334-.47.715-.345 1.192.079.304.259.537.472.74M20.453 17.68a.75.75 0 0 0-1.061 0l-1.536 1.537v-4.848a.75.75 0 0 0-1.5 0v4.849L14.82 17.68a.749.749 0 1 0-1.06 1.06l2.815 2.82c.034.033.077.05.116.078.042.028.078.063.125.083a.8.8 0 0 0 .289.059c.023 0 .043-.011.065-.013a.8.8 0 0 0 .224-.045.8.8 0 0 0 .245-.165l2.814-2.816a.75.75 0 0 0 0-1.061"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgDatabaseImportFilled);
export default ForwardRef;
